import React from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import useFirestore from "../../../../config/fireBaseHook";
import { formatDate } from "../../../../utils/formatDate";

const CourseProctorApp = () => {
  const { data, loading, error } = useFirestore(
    "CourseProctorApp",
    "Date_Submitted",
    "desc",
  );

  const columns = [
    {
      field: "Date_Submitted",
      headerName: "Date Submitted",
      flex: 1,
      valueFormatter: (value) => formatDate(value) || "N/A",
    },
    {
      field: "schoolName",
      headerName: "School Name",
      flex: 1,
    },
    {
      field: "fromName",
      headerName: "From Name",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Proctor Name",
      flex: 1,
    },
    {
      field: "phone",
      headerName: "Phone",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "fromEmail",
      headerName: "From Email",
      flex: 1,
    },
    {
      field: "pathwayEmail",
      headerName: "Pathway Email",
      flex: 1,
    },
    {
      field: "opEmail",
      headerName: "OP Email",
      flex: 1,
    },
    {
      field: "schoolId",
      headerName: "School ID",
      flex: 0.5,
    },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <AppDataGrid
        rows={data}
        columns={columns}
        loading={loading}
        slots={{ toolbar: GridToolbarNoExport }}
        pagination
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        disableSelectionOnClick
      />
    </>
  );
};

export default CourseProctorApp;
